"use strict";
exports.__esModule = true;
var Pubsub = require("pubsub-js");
var Microcache = require("microcache");
var cache = new Microcache();
var PubsubReplay = /** @class */ (function () {
    function PubsubReplay() {
    }
    /**
     * Publishes content to a topic
     * @param topic
     * @param data
     */
    PubsubReplay.publish = function (topic, data) {
        cache.set(topic, data);
        return Pubsub.publish(topic, data);
    };
    /**
     * Subscribes to a topic
     * @param topic The topic to subscribe to
     * @param func The function to execute when new events are received
     * @param replay Wether or not to call the function with a previously received event
     * @return The subscription token, that may be canceled calling `unsubscribe`
     */
    PubsubReplay.subscribe = function (topic, func, replay) {
        if (replay === void 0) { replay = false; }
        // replay previous events
        if (replay) {
            var data = cache.get(topic);
            if (data) {
                func(topic, data);
            }
        }
        // subscribe the client to pubsub
        return Pubsub.subscribe(topic, func);
    };
    /**
     * Cancels all further notifications to the topic or clears all
     * further notifications for the function that returned the token
     * @param tokenOrTopic The token received from `subscribe`, or the name of the topic
     */
    PubsubReplay.unsubscribe = function (tokenOrTopic) {
        return Pubsub.unsubscribe(tokenOrTopic);
    };
    /**
     * Clears all subscriptions calling `pubsub-js`'s clearAllSubscriptions function
     */
    PubsubReplay.clearAllSubscriptions = function () {
        return Pubsub.clearAllSubscriptions();
    };
    return PubsubReplay;
}());
exports.PubsubReplay = PubsubReplay;
